module.exports = __webpack_public_path__ + "assets/hour_glass.048124182e285ff97b0c533fe6c837bc.gif";